/**
 *
 * @param originUrl import env from '@env' 객체의 KC_IAM_ENDPOINT 값을 전달합니다. server side 일 때에도 올바른 경로로 보내기 위한 대체 주소로 활용합니다. (미설정 시, server side의 origin은 빈 문자열로 반환됩니다.)
 * @returns client / server side 에 알맞는 baseUrl을 반환합니다.
 */
export const setOriginUrl = (originUrl?: string) => {
  // 1. window 객체가 없을 시, server side 실행 시점이라고 판단
  const isServer = typeof window === 'undefined';

  let baseOrigin = '';

  if (isServer) {
    // 2. server side 일 경우, baseOrigin: iam endpoint 참조 (iam endpoint sub domain과 console | account sub domain은 세트로 움직이기에)
    baseOrigin = originUrl ?? '';
  } else {
    // 3. client side 일 경우, window.location.origin 참조
    baseOrigin = window.location.origin;
  }

  // 4. baseOrigin 주소 끝에 붙어있는 :0000 port number 제거
  return baseOrigin.replace(/:\d+$/, '');
};
